import { render, staticRenderFns } from "./ScreeningsUpdateBuilder.vue?vue&type=template&id=10743b3c&scoped=true&"
import script from "./ScreeningsUpdateBuilder.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateBuilder.vue?vue&type=style&index=0&id=10743b3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10743b3c",
  null
  
)

export default component.exports